module.exports = __webpack_public_path__ + "img/icon-caution.ecd5fb58.svg";